import React, { useState } from 'react';

import classNames from 'classnames';

import MinusIcon from 'Assets/icons/minus.svg';
import PlusIcon from 'Assets/icons/plus.svg';

export default function SectionTile({
    header,
    subHeader,
    collapsed: controlledCollapsed,
    defaultCollapsed = false,
    visibly,
    flat,
    children,
    filtersModal,
    onToggle,
    /* The toggle is icon-only, so it announces as a bare "button" without
       this. Optional rather than required: existing callers keep the behaviour
       they shipped with. */
    toggleLabel,
    /* Names the region the toggle controls, completing the disclosure pattern.
       Pair it with `visibly` — aria-controls has to point at an element that is
       in the DOM, and the default variant unmounts the region when collapsed. */
    contentId,
}) {
    const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);

    const isControlled = controlledCollapsed !== undefined;
    const collapsed = isControlled ? controlledCollapsed : internalCollapsed;

    const handleToggle = () => {
        if (isControlled) {
            onToggle?.();
        } else {
            setInternalCollapsed((prev) => !prev);
            onToggle?.();
        }
    };

    return (
        <div className={classNames({ 'tw-px-6 tw-py-6.5 tw-rounded-lg tw-bg-white tw-shadow-primary': !flat })}>
            <div className="tw-flex tw-justify-between tw-items-start">
                <div>
                    <h3 className="table__header">{header}</h3>
                    {!!subHeader && <p className="tw-mt-1 tw-text-[12.5px] tw-text-charcoal-50">{subHeader}</p>}
                </div>
                <div className="tw-flex tw-gap-x-1.5">
                    {filtersModal}
                    <button
                        className="table__icon-btn tw-text-white"
                        onClick={handleToggle}
                        aria-expanded={!collapsed}
                        aria-label={toggleLabel}
                        aria-controls={visibly ? contentId : undefined}
                    >
                        {collapsed && <PlusIcon className="tw-w-3.5 tw-h-3.5" />}
                        {!collapsed && <MinusIcon className="tw-w-3.5 tw-h-3.5" />}
                    </button>
                </div>
            </div>
            {visibly ? (
                <div
                    id={contentId}
                    /* Programmatically focusable, not tabbable: a caller that
                       opens this region from elsewhere on the page has
                       somewhere to send focus. */
                    tabIndex={contentId ? -1 : undefined}
                    className={classNames('tw-mt-6', collapsed && '!tw-hidden')}
                >
                    {children}
                </div>
            ) : (
                !collapsed && <div className="tw-mt-6">{children}</div>
            )}
        </div>
    );
}
